module.exports = __webpack_public_path__ + "static/media/399SunsetAveNW_2018-06-11_67.5a6488b9.jpg";